// extracted by mini-css-extract-plugin
export default {"stackTraceContainer":"L3Wywk5bqCgilvRxqa80"};